import { ValidationResultItem } from '../typings/common';
import { AppFlatSettings, AppFromApiData, AppInfo, AppShowInAd } from '../typings/mobile-apps';

export const FETCH_APP_INFO = 'FETCH_APP_INFO';
export type FETCH_APP_INFO = typeof FETCH_APP_INFO;

export interface FetchAppInfo {
    type: FETCH_APP_INFO;
    link: string;
    login: string;
}

export function fetchAppInfo(link: string, login: string): FetchAppInfo {
    return {
        type: FETCH_APP_INFO,
        link,
        login
    };
}

export const UPDATE_APP_INFO = 'UPDATE_APP_INFO';
export type UPDATE_APP_INFO = typeof UPDATE_APP_INFO;

export interface UpdateAppInfo {
    type: UPDATE_APP_INFO;
    appInfo?: AppInfo;
}

export function updateAppInfo(appInfo?: AppInfo): UpdateAppInfo {
    return {
        type: UPDATE_APP_INFO,
        appInfo: appInfo
    };
}

// "Show in AD" group changed
export const SHOW_IN_AD_CHANGE = 'SHOW_IN_AD_CHANGE';
export type SHOW_IN_AD_CHANGE = typeof SHOW_IN_AD_CHANGE;

export interface ShowInAdChange {
    type: SHOW_IN_AD_CHANGE;
    value: AppShowInAd;
}

export function showInAdChange(value: AppShowInAd): ShowInAdChange {
    return {
        type: SHOW_IN_AD_CHANGE,
        value
    };
}

// App 'Flat' Settings change event
export const APP_FLAT_SETTINGS_CHANGE = 'APP_FLAT_SETTINGS_CHANGE';
export type APP_FLAT_SETTINGS_CHANGE = typeof APP_FLAT_SETTINGS_CHANGE;

export interface AppFlatSettingsChange {
    type: APP_FLAT_SETTINGS_CHANGE;
    value: AppFlatSettings;
}

export function appFlatSettingsChange(value: AppFlatSettings): AppFlatSettingsChange {
    return {
        type: APP_FLAT_SETTINGS_CHANGE,
        value
    };
}

export const SHOW_FETCH_CREATE_APP_ERROR = 'SHOW_FETCH_CREATE_APP_ERROR';
export type SHOW_FETCH_CREATE_APP_ERROR = typeof SHOW_FETCH_CREATE_APP_ERROR;

export interface ShowFetchCreateAppError {
    type: SHOW_FETCH_CREATE_APP_ERROR;
    errors: ValidationResultItem[];
}

export function showFetchCreateAppError(errors: ValidationResultItem[]): ShowFetchCreateAppError {
    return {
        type: SHOW_FETCH_CREATE_APP_ERROR,
        errors
    };
}

export const SET_INITIAL_CREATE_APP_PAGE_STATUS = 'SET_INITIAL_CREATE_APP_PAGE_STATUS';
export type SET_INITIAL_CREATE_APP_PAGE_STATUS = typeof SET_INITIAL_CREATE_APP_PAGE_STATUS;

export interface SetInitialCreateAppPageStatus {
    type: SET_INITIAL_CREATE_APP_PAGE_STATUS;
}

export function setInitialCreateAppPageStatus(): SetInitialCreateAppPageStatus {
    return {
        type: SET_INITIAL_CREATE_APP_PAGE_STATUS
    };
}

export const CLEAR_MOBILE_APPS_ERROR = 'CLEAR_MOBILE_APPS_ERROR';
export type CLEAR_MOBILE_APPS_ERROR = typeof CLEAR_MOBILE_APPS_ERROR;

export interface ClearCreateMobileAppsErrors {
    type: CLEAR_MOBILE_APPS_ERROR;
    pathes: string[];
}

export function clearCreateMobileAppsErrors(pathes: string[]): ClearCreateMobileAppsErrors {
    return {
        type: CLEAR_MOBILE_APPS_ERROR,
        pathes
    };
}

// Add App
export const ADD_MOBILE_APP = 'ADD_MOBILE_APP';
export type ADD_MOBILE_APP = typeof ADD_MOBILE_APP;

export interface AddMobileApp {
    type: ADD_MOBILE_APP;
    login: string;
    extOnSaveCallback?: () => void;
}

export function addMobileApp(login: string, extOnSaveCallback?: () => void): AddMobileApp {
    return {
        type: ADD_MOBILE_APP,
        login,
        extOnSaveCallback
    };
}

// Fetch app data
export const FETCH_APP_DATA = 'FETCH_APP_DATA';
export type FETCH_APP_DATA = typeof FETCH_APP_DATA;

export interface FetchAppData {
    type: FETCH_APP_DATA;
    id: string;
    login: string;
}

export function fetchApp(id: string, login: string): FetchAppData {
    return {
        type: FETCH_APP_DATA,
        id,
        login
    };
}

// Fill app data
export const FILL_APP_DATA = 'FILL_APP_DATA';
export type FILL_APP_DATA = typeof FILL_APP_DATA;

export interface FillAppData {
    type: FILL_APP_DATA;
    app?: AppFromApiData;
}

export function fillAppData(app?: AppFromApiData): FillAppData {
    return {
        type: FILL_APP_DATA,
        app
    };
}

// Update App
export const UPDATE_MOBILE_APP = 'UPDATE_MOBILE_APP';
export type UPDATE_MOBILE_APP = typeof UPDATE_MOBILE_APP;

export interface UpdateMobileApp {
    type: UPDATE_MOBILE_APP;
    login: string;
    extOnSaveCallback?: () => void;
}

export function updateMobileApp(login: string, extOnSaveCallback?: () => void): UpdateMobileApp {
    return {
        type: UPDATE_MOBILE_APP,
        login,
        extOnSaveCallback
    };
}

export type MobileAppsCreateAction =
    | FetchAppInfo
    | UpdateAppInfo
    | ShowFetchCreateAppError
    | ClearCreateMobileAppsErrors
    | ShowInAdChange
    | AppFlatSettingsChange
    | AddMobileApp
    | FetchAppData
    | FillAppData
    | SetInitialCreateAppPageStatus
    | UpdateMobileApp;
